import { LogExperimentRepresentation } from 'types/webAPI.definition'
import http from './http'

export default class experimentApi {
  static logExperiment(data: LogExperimentRepresentation) {
    return http.post('/api/experiment/log', data)
  }
}
